
import { defineComponent } from 'vue'
import EmployeesCreateNewForm from '@/components/employees/forms/create-new.vue'
import { useEmployeeModule } from '@/modules/employees'

export default defineComponent({
    name: 'view-employees-new-employee',
    components: { EmployeesCreateNewForm },
    setup () {
        const { loadAvailableRoles } = useEmployeeModule()
        loadAvailableRoles()
        return {}
    }
})
